import { StatusDot } from "@shared/components/blocks";
import { useT } from "@shared/client/locale";

const STATUS_TONES: Record<string, string> = {
  completed: "success",
  failed: "danger",
  cancelled: "neutral",
  in_progress: "info",
  queued: "info",
};

/**
 * État d'un passage : un point de couleur suivi d'un mot. Le libellé reste
 * lisible sans la couleur, et la ligne ne se couvre pas de pastilles.
 */
export function StatusBadge({ status, className }: { status: string; className?: string }) {
  const t = useT();
  return (
    <StatusDot className={className} tone={STATUS_TONES[status] ?? "neutral"}>
      {t.leads.runStatuses[status] ?? status}
    </StatusDot>
  );
}
